(() => {
  function enhance(root) {
    root.querySelectorAll('.article__wrapper .sp-guide .sp-table:not([data-sp-stacked])').forEach(table => {
      const headers = Array.from(table.querySelectorAll('thead tr:first-child th'));
      const rows = Array.from(table.querySelectorAll('tbody tr'));
      if (!headers.length || !rows.length || rows.some(row => row.cells.length !== headers.length || Array.from(row.cells).some(cell => cell.colSpan !== 1 || cell.rowSpan !== 1))) return;
      rows.forEach(row => Array.from(row.cells).forEach((cell, index) => {
        if (index > 0) cell.setAttribute('data-sp-label', headers[index].textContent.trim());
      }));
      table.setAttribute('data-sp-stacked', '');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document), {once: true});
  else enhance(document);
  document.addEventListener('shopify:section:load', () => enhance(document));
})();